import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ReactGA from 'react-ga4';

ReactGA.initialize('G-KT0QJMJ1F5'); // Replace with your GA4 Measurement ID
ReactGA.send({ hitType: "pageview", page: window.location.pathname });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
